<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { computed } from "vue"
import { useI18n } from "vue-i18n"

// ================================
// INTERNATIONALIZATION
// ================================

const { t } = useI18n({
    messages: {
        fr: {
            title: "Informations personnelles",
            subtitle: "Gérez vos informations personnelles",
            breadcrumb: {
                accueil: "Accueil",
                utilisateur: "Utilisateur",
                param: "Informations personnelles",
            },
        },
    },
})

// ================================
// COMPUTED
// ================================
/**
 * Retourne le breadcrumb de la page
 * @returns Le breadcrumb de la page
 */
const getBreadcrumb = computed(() => {
    return [
        { icon: "pi pi-home", label: t("breadcrumb.accueil"), route: "/" },
        {
            icon: "pi pi-user",
            label: t("breadcrumb.utilisateur"),
        },
        { icon: "pi pi-bell", label: t("breadcrumb.param") },
    ]
})
</script>

<template>
    <div class="page page-user-settings">
        <!-- Header avec titre -->
        <HeaderPage
            :title="t('title')"
            :breadcrumb="getBreadcrumb"
            class-header="flex flex-col gap-4"
        >
            <p class="text-gray-600 text-sm">
                {{ t("subtitle") }}
            </p>
        </HeaderPage>
        <FormUserInfo />
    </div>
</template>
